class ExecutionContext {
    public static IsServerSide(): boolean {
        // Episerver Spa Core defines window shim on server side but does not assign `window` property to itself
        return typeof window === 'undefined' || typeof window.window === 'undefined';
    }

    public static ThrowIfServerSide(): void {
        if (ExecutionContext.IsServerSide()) {
            throw new Error("Method shouldn't be used in server side");
        }
    }
}

export default ExecutionContext;
